import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcSorting(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.25 3a.75.75 0 0 1 1.5 0v16.19l1.72-1.72a.75.75 0 1 1 1.06 1.06l-3 3a.75.75 0 0 1-1.06 0l-3-3a.75.75 0 1 1 1.06-1.06l1.72 1.72zm8 18V4.81l-1.72 1.72a.75.75 0 1 1-1.06-1.06l3-3 .114-.094a.75.75 0 0 1 .946.094l3 3a.75.75 0 1 1-1.06 1.06l-1.72-1.72V21a.75.75 0 1 1-1.5 0"
  }));
}
var IcSorting = createNolIcon(/*#__PURE__*/forwardRef(SvgIcSorting));

export { IcSorting as I };
